
    $(function() {
        let paletteArray = [];  
        const paletteLimit = $(".palette-container").attr('data-limit'); 

        // Add and remove colors to the palette
        $("input[type=checkbox].palette-checkbox").on("change", function() {
            const imageURL = $(this).attr('data-img'); 
            const imageID = $(this).attr('id'); 
            const name = $(this).attr('data-name'); 
            const productURL = $(this).attr('data-url'); 

            if($(this).prop('checked')) {
                if( paletteArray.length >= paletteLimit ) {
                    $(this).prop('checked', false)
                    alert(`You may only add ${paletteLimit} colors to your palette at a time`); 
                    return; 
                } else {
                    $(this).next().children().addClass('color-selected');      
                    addToArray( paletteArray, imageURL, imageID, name, productURL ); 
                    renderHTML( paletteArray, $('.palette-container'), $('.color-names'));
                    updateButton( paletteArray, $(".palette-submit")); 
                }
            }else {                
                // prevent checkbox from getting unchecked 
                $(this).prop('checked', true); 
                // This allows for a color to be added more than once
                if( paletteArray.length >= paletteLimit ) {
                    $(this).prop('checked', false)
                    alert(`You may only add ${paletteLimit} colors to your palette at a time`); 
                    return; 
                } else {
                    $(this).next().children().addClass('color-selected');      
                    addToArray( paletteArray, imageURL, imageID, name, productURL ); 
                    renderHTML( paletteArray, $('.palette-container'), $('.color-names'));
                    updateButton( paletteArray, $(".palette-submit")); 
                }
            }  
        }); //end on change event


        // remove colors from palette by clicking on the images on the right
        $(".palette-container").on("click", function(event) { 
            if($(event.target).attr('data-id')) {
                const imageID = $(event.target).attr('data-id'); 
                removeFromArray( paletteArray, imageID ); 
                renderHTML( paletteArray, $('.palette-container'), $('.color-names')); 
                // check to see if there is a color in the array before unchecking the form on the right. - use for multiples
                let color = paletteArray.find(o => o.id === imageID );
                if( color === undefined ){
                    console.log("undefined"); 
                    updateCheckboxes( imageID );
                }
                // updateCheckboxes( imageID ); // use if not allowing multiples
                updateButton( paletteArray, $(".palette-submit")); 
            } 
         });

         $("#clear-all").on("click", function(event) {
             event.preventDefault(); 
             paletteArray.forEach(function(color) {
               updateCheckboxes(color.id); 
             })
             paletteArray = []; 
             renderHTML( paletteArray, $('.palette-container'), $('.color-names')); 
             updateButton( paletteArray, $(".palette-submit")); 
         });

         //palette functions
         function updateCheckboxes( id ) { 
            $(".palette-checkbox").map( function() {
                if($(this).attr('id') === id && $(this).prop('checked')) {
                    $(this).prop('checked', false )
                    $(this).next().children().removeClass('color-selected'); 
                }
            });
         }

        function addToArray( array, image, id, name, link) {
            array.push( 
                 { 
                     div : `<div class="color" id="${ id }" >
                                <span class="icon-cross palette-color-icon" data-id="${ id }"></span>
                                 <div class="palette-color-hover" data-id="${ id }"><p data-id="${ id }">${ name }</p></div>
                                 <img src="${image}">
                             </div>`, 
                     id: id, 
                     name: name, 
                     li: `<li>${name}</li>`,
                     productUrl: link
                 } 
             );
         }

         function removeFromArray( array, id ){
            let indexOfColorToRemove = array.findIndex((element) =>  element.id === id ); 
            array.splice( indexOfColorToRemove, 1 );
         }

         function renderHTML( array,  container1, container2 ) {
                let paletteString = '';
                let nameString = ''; 

                array.forEach( (color) => {
                    paletteString += color.div; 
                    nameString += color.li; 
                });

                container1.html( paletteString );
                container2.html( nameString );
         }

         function updateButton( array, buttonID ) {
             if (array.length > 0 && buttonID.hasClass('disabled')) {
                buttonID.removeClass('disabled')
             } else if (array.length === 0 && ! buttonID.hasClass('disabled')) {
                 buttonID.addClass('disabled'); 
             } 

             if( paletteArray.length >= 2 ) {
                $(".save-palette-container").css("opacity", "1"); 
            } else {
                $(".save-palette-container").css("opacity", "0");
            }
         }//end palette functions


        // sticky palette container - on widths less than 1024px
        if($(window).width() <= 1024 ) {
            $(".pb-column.column-1").css("padding-bottom", $(".pb-column.column-2").height()); 

            $(window).scroll(function() {
            
                let elementToStickUnder = $("#palette-builder-form"); 
                let staticTop = elementToStickUnder.offset().top + elementToStickUnder.height() + 60; //20 is the added margin to the bottom of the form element
                let stickyPalette = $(".pb-column.column-2");
                let windowHeight = $(window).height() - stickyPalette.height(); 
                let bottomScreen = $(window).scrollTop() + windowHeight; 

                if (bottomScreen > staticTop ) {
                    stickyPalette.css("position", "relative");
                    $(".pb-column.column-1").css("padding-bottom", "0"); 
                }else {
                    stickyPalette.css("position", "fixed");
                    $(".pb-column.column-1").css("padding-bottom", $(".pb-column.column-2").height());
                }
            }); 

        }  

        // use AJAX to send items to cart
        $('button.palette-submit').on("click", function(event) {
            event.preventDefault(); 
    
            // loop through product checkboxes and add checked items to form data array
            let formData = [];
            // $(".palette-checkbox").map( function() {
            //     if($(this).prop('checked')) {
            //         let item = {
            //             id: $(this).val(), 
            //             quantity: 1
            //         }
            //         formData.push(item); 
            //     }
            // });
            
            // Option to add products based on array rather than form
            paletteArray.map( function(color) {
                    let item = {
                        id: color.id, 
                        quantity: 1
                    }
                    formData.push(item); 
            });

        
            $.post('/cart/add.js',  { items: formData }, function(data) {
                $(".palette-submit span.text").html('');
                $(".palette-submit .checkmark").addClass('checkmark-active');
                // console.log(data); 
            })
            .done( function(data) {
                //redirect to cart page
                // window.location.replace( "/cart"); 
                setTimeout(function() { 
                    $(".palette-submit span.text").html('Add Palette To Cart');
                    $(".palette-submit .checkmark").removeClass('checkmark-active');
                }, 2000);
               
            })
            .fail(function( error ) {
                console.log(error); 
                setTimeout(function() { 
                    $(".palette-submit span.text").html("Sorry, Something Went Wrong");
                    $(".palette-submit .checkmark").removeClass('checkmark-active');
                }, 2000);
            }); 

           
        });
    

        // use AJAX to send items to APP for saving
        $('button.palette-save').on("click", function(event) {
            event.preventDefault(); 
    
            // loop through product checkboxes and add checked items to form data array
            let action_url = $(event.currentTarget).val();
            let formData = {};
            let colors = [];
            
            // Option to add products based on array rather than form
            paletteArray.map( function(color) {
                colors.push(color.id);
            });

            formData['cid'] = $('input[name="cid"]').val();
            formData['hcid'] = $('input[name="hcid"]').val();
            formData['collection'] = $('input[name="collection"]').val();
            formData['palette_name'] = $('input[name="palette_name"]').val();;
            formData['colors'] = colors.join(', ');
        
            $.post(action_url, formData, function(data) {
                $(".palette-save span.text").html('');
                $(".palette-save .checkmark").addClass('checkmark-active');
                // console.log(data); 
            })
            .done( function(data) {
                setTimeout(function() { 
                    $(".palette-save span.text").html('Save to my account');
                    $(".palette-save .checkmark").removeClass('checkmark-active');
                }, 2000);
               
            })
            .fail(function( error ) {
                console.log(error); 
                setTimeout(function() { 
                    $(".palette-save span.text").html("Sorry, Something Went Wrong");
                    $(".palette-save .checkmark").removeClass('checkmark-active');
                }, 2000);
            }); 

           
        });

    });


